export const frag = /*glsl*/ `
precision mediump float;

uniform vec3 uColor;
varying float vPosLength;

#define PI 3.141592

float pow2(float x) {return x*x;}
void main() {
  vec2 vUv = gl_PointCoord - .5;
  float l = abs(vUv.x + vUv.y * .2);

  float a = pow2(smoothstep(.3, .0, l));
  a *= smoothstep(10., 0., vPosLength);

  if (a < .001) discard;
  gl_FragColor = vec4(a * .2);
}`;
